<script setup>
import { storeToRefs } from 'pinia'
import { useMessageStore } from '~/stores/messages'

const props = defineProps({
    shops: {
        type: Object,
        default: () => ({}),
        validator(rawValue) {
            const validations = {
                list: rawValue => typeof rawValue === 'object' && rawValue !== null,
                letter: rawValue => Object.keys(rawValue).every(letter => typeof letter === 'string')
            }

            return Object.entries(validations).every(([_, validate]) => validate(rawValue))
        }
    }
})

// Fetch messages
const messagesStore = useMessageStore()
const { messages: staticKeys } = storeToRefs(messagesStore)

// Compute shops
const hasShops = computed(() => Object.keys(props.shops).length > 0)
</script>

<template>
    <ul v-if="hasShops" class="shop-list">
        <template
            v-for="(shopList, letter) in shops"
            :key="`divider-${letter}`"
        >
            <li v-if="letter !== 'placeholder'" class="shop-list-divider">
                {{ (letter !== '.') ? `${letter[0]}.` : letter[0] }}
            </li>

            <ShopListItem
                v-for="(shop, index) in shopList"
                :key="`shop-${index}`"
                :shop="{ ...shop, placeholder: shops.placeholder }"
            />
        </template>
    </ul>

    <p v-else>
        {{ staticKeys?.shops_empty_filter_search }}
    </p>
</template>

 <style lang="scss">
 .shop-list {
     display: grid;
     grid-template-columns: 1fr 1fr;
     grid-auto-rows: minmax(0, auto);
     list-style-type: none;
     gap: 16px;
     margin: 0;
     padding: 0 0 px2rem(80);

     @include bp(936px) {
         grid-template-columns: 1fr 1fr 1fr;
         gap: 30px;
     }

     @include bp(1248px) {
         grid-template-columns: 1fr 1fr 1fr 1fr;
     }
 }

 .shop-list-divider {
     grid-column: 1 / -1;
     font-size: px2rem(20);
     font-weight: bold;
     margin-block: px2rem(19) px2rem(8);

     &:first-child {
         margin-block-start: 0;
     }
 }
</style>
